import { inject } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import type { ResolveFn } from '@angular/router';
import type { PartialDeep } from 'type-fest';
import { CacheService } from '../../../../../common/services/cache.service';
import type { PointsOfInterestFormResolverData } from '../../points-of-interest.routes';
import { PointsOfInterestQueryParamKey } from '../enums/points-of-interest-query-param-key';
import { PointsOfInterestStorageKey } from '../enums/points-of-interest-storage-key';
import type { PointOfInterestForm } from '../helpers/point-of-interest-form.helper';
import { PointOfInterestFormHelper } from '../helpers/point-of-interest-form.helper';

export const addPointOfInterestResolver: ResolveFn<
  PartialDeep<PointsOfInterestFormResolverData>
> = (route) => {
  const cacheService = inject(CacheService);
  const fb = inject(NonNullableFormBuilder);

  const cacheKey = PointsOfInterestStorageKey.ADD_POINT_OF_INTEREST_FORM;
  const cache = cacheService.get<PartialDeep<PointOfInterestForm>>(cacheKey, {
    keepOnNavigation: true,
  });

  const name =
    route.queryParamMap.get(PointsOfInterestQueryParamKey.NAME) ?? '';
  const form = PointOfInterestFormHelper.buildForm(fb);
  const baseForm = form.getRawValue();
  const initial: PartialDeep<PointOfInterestForm> = {
    ...baseForm,
    pointInformation: {
      ...baseForm.pointInformation,
      name,
    },
  };

  return { form: cache ?? initial, initial };
};
